/* B&B Journal: reveals, glow, parallax, reading progress, share */
(function(){
  function init(root){
    if(!root||root.__bbj)return;root.__bbj=1;
    var rm=window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches;
    function go(){requestAnimationFrame(function(){requestAnimationFrame(function(){root.classList.add('ready')})})}
    if(document.documentElement.classList.contains('bbi-lock')){document.addEventListener('bb:intro-done',go,{once:true});setTimeout(go,6000)}else go();
    var rv=root.querySelectorAll('.rv');
    if('IntersectionObserver' in window&&!rm){
      var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target)}})},{rootMargin:'0px 0px -8% 0px',threshold:.08});
      rv.forEach(function(el){io.observe(el)});
    }else rv.forEach(function(el){el.classList.add('in')});
    root.querySelectorAll('[data-glow]').forEach(function(h){
      h.addEventListener('pointermove',function(e){var r=h.getBoundingClientRect();h.style.setProperty('--mx',((e.clientX-r.left)/r.width*100).toFixed(1)+'%');h.style.setProperty('--my',((e.clientY-r.top)/r.height*100).toFixed(1)+'%')});
    });
    var par=[].slice.call(root.querySelectorAll('.bbj-feat__m img,.bbj-cover img')),big=root.querySelector('.bbj-hero__big'),bar=root.querySelector('.bbj-prog'),body=root.querySelector('.bbj-rte'),tk=false;
    if(bar&&bar.parentNode!==document.body)document.body.appendChild(bar);
    function frame(){
      tk=false;var vh=innerHeight;
      if(!rm){par.forEach(function(el){var r=el.parentNode.getBoundingClientRect();if(r.bottom<0||r.top>vh)return;var k=(r.top+r.height/2-vh/2)/vh;el.style.setProperty('--py',(k*-40).toFixed(1)+'px')});
      if(big)big.style.setProperty('--px',(scrollY*-.25).toFixed(1)+'px');}
      if(bar&&body){var b=body.getBoundingClientRect(),t=b.height-vh*.6,p=t>0?Math.min(1,Math.max(0,-b.top+vh*.3)/t):0;bar.style.transform='scaleX('+p.toFixed(4)+')'}
    }
    addEventListener('scroll',function(){if(!tk){tk=true;requestAnimationFrame(frame)}},{passive:true});frame();
    root.querySelectorAll('[data-copy]').forEach(function(b){
      b.addEventListener('click',function(){var u=location.href.split('#')[0],l=b.querySelector('span')||b,o=l.textContent;
        function ok(){l.textContent=b.getAttribute('data-done')||'Copied';setTimeout(function(){l.textContent=o},1800)}
        if(navigator.clipboard)navigator.clipboard.writeText(u).then(ok,ok);else ok()});
    });
    root.querySelectorAll('[data-native]').forEach(function(b){
      if(!navigator.share){b.hidden=true;return}
      b.addEventListener('click',function(){navigator.share({title:document.title,url:location.href}).catch(function(){})});
    });
  }
  function all(){document.querySelectorAll('.bbj').forEach(init)}
  if(document.readyState!=='loading')all();else document.addEventListener('DOMContentLoaded',all);
  document.addEventListener('shopify:section:load',function(e){var r=e.target.querySelector('.bbj');if(r){r.__bbj=0;init(r)}});
})();
